<!-- <div *ngIf="error" matTooltip="{{errorMensaje}}" [matTooltipPosition]="'after'" matTooltipClass="custom-tooltip"> -->
<div *ngIf="error" class="tooltip">
  <app-custom-tooltip-sqp [textoTooltip]="errorMensaje" [posicion]="'bottom'"></app-custom-tooltip-sqp>
    <svg style="color: #D92D20; height: 25px; width: 25px; margin: 5px">
        <use xlink:href="#hs-alert"></use>
    </svg>
</div>
